import {useToast} from "@shopify/app-bridge-react";
import {useCallback, useEffect, useState} from "react";
import Api from "../../../helpers/api";
import {
    Button,
    Modal,
    Select,
    DropZone,
    FormLayout,
    LegacyStack,
    Text,
    DataTable,
    Badge,
    OptionList, RadioButton, InlineStack
} from "@shopify/polaris";
import {formatDateToUsFormat} from "../../Dates";

export default ({
    loading = false,
    type,
    listReload = 0,
    products_type = null,
    onRefresh = () => {}
}) => {
    const toast = useToast();
    const [loadingImports, setLoadingImports] = useState(false);
    const [downloadingFile, setDownloadingFile] = useState(false);
    const [cancelling, setCancelling] = useState(false);

    const [imports, setImports] = useState([]);

    useEffect(() => {
        loadImports();
    }, []);

    useEffect(() => {
        loadImports();
    }, [listReload]);

    const loadImports = () => {
        setLoadingImports(true);

        Api
            .getImportsList(type, products_type)
            .then(({data}) => {
                setImports(data.data);
            })
            .catch(() => {
                toast.show("Server error. Please try again");
            })
            .finally(() => {
                setLoadingImports(false);
                onRefresh();
            })
    }

    const downloadFile = (data, title) => {
        const blob = new Blob([data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')

        a.setAttribute('href', url)
        a.setAttribute('download', title);
        a.click();
        a.remove();
    }

    const downloadLogFile = (row) => {
        setDownloadingFile(true);
        Api
            .getImportLog(row.id)
            .then((data) => {
                downloadFile(data.data, row.log_file_name);
            })
            .catch(() => {
                toast.show("Server error. Please try again");
            })
            .finally(() => setDownloadingFile(false));
    };

    const cancelImport = (row) => {
        setCancelling(true);
        Api
            .cancelImport(row.id)
            .then(() => {
                toast.show("Import has been cancelled");
                loadImports();
            })
            .catch(() => {
                toast.show("Server error. Please try again");
            })
            .finally(() => setCancelling(false));
    };

    return (<>
        <LegacyStack>
                <LegacyStack.Item fill>
                    <Text as={'h4'} fontWeight={'bold'} variant={'headingMd'}>Imports</Text>
                </LegacyStack.Item>
                <LegacyStack.Item>
                    <Button
                        disabled={loading || downloadingFile}
                        loading={loadingImports}
                        onClick={() => loadImports()}
                    >Refresh</Button>
                </LegacyStack.Item>
            </LegacyStack>
            <DataTable
                columnContentTypes={[
                    'text',
                    'text',
                    'text',
                    'text',
                    'text',
                ]}
                headings={[
                    'File',
                    '% Progress',
                    'Started At',
                    'Finished At',
                    '',
                ]}
                rows={imports.map(row => [
                    <LegacyStack vertical>
                        <Text as={'span'}>{row.file_name}</Text>
                        <InlineStack gap={200}>
                            {row.badges.map(badge => <Badge tone={badge.tone} progress={badge.progress}>{badge.title}</Badge>)}
                        </InlineStack>
                    </LegacyStack>,
                    row.progress,
                    formatDateToUsFormat(row.created_at),
                    <Text as={'span'}>{!!row.finished_at ? formatDateToUsFormat(row.finished_at) : ''}</Text>,
                    <InlineStack gap={'200'} wrap={false}>
                        <Button
                            disabled={loading || loadingImports}
                            loading={downloadingFile}
                            onClick={() => downloadLogFile(row)}
                        >Logs</Button>
                        {!row.finished && <Button
                            disabled={loading || loadingImports}
                            loading={cancelling}
                            onClick={() => {
                                if (confirm("Are you sure you want to cancel this import? This cannot be undone!")) {
                                    cancelImport(row);
                                }
                            }}
                            variant={'primary'}
                            tone={'critical'}
                        >Cancel</Button>}
                    </InlineStack>
                ])}
            />
    </>);
}
